/**
 * Created by shubham on 16/4/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { UserComponent } from './user.component';
import { AddEditUserComponent } from './add-edit-user/add-edit-user.component';

export const UserRoutes: Routes = [
    {
        path: '',
        component: UserComponent,
        children: [
            { path: '', redirectTo: '/app/partners-dashboard', pathMatch: 'full' },
            { path: 'add', component: AddEditUserComponent },
            { path: 'edit/:id', component: AddEditUserComponent }
        ]
    }
];

export const UserRoutingModule = RouterModule.forChild(UserRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user/user-routing.module.ts